import React from "react"
import { useRecoilState } from "recoil"
import { makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import StepContent from "@material-ui/core/StepContent"
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"

import AssociationInfoForm from "../../forms/AssociationInfo"
// import BillingInfoForm from "../../forms/BillingInfo"
import BillingInfoBetaForm from "../../forms/BillingInfoBeta"
import LocationForm from "../../forms/Location"
import onboardingProgress from "../../store/onboardingProgress"

const stripeKey = "pk_test_AsxfayWjT64zh8KLOjXDmKwD"
// process.env.NODE_ENV === "production"
//   ? "pk_live_abyhOXwnlOefLcAEzn1NQHcN"
//   : "pk_test_AsxfayWjT64zh8KLOjXDmKwD"
const stripePromise = loadStripe(stripeKey)

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}))

function getSteps(progress) {
  return [
    {
      form: <LocationForm />,
      title: "Association Address",
    },
    {
      form: <AssociationInfoForm />,
      title: "Association Information",
    },
    {
      form: <BillingInfoBetaForm nextText="Create Association" />,
      title: "Billing Information",
    },
    // {
    //   title: "Association Documents",
    // },
    // {
    //   title: "Invite Members",
    // },
  ]
}

export default function User() {
  const classes = useStyles()
  const [progress] = useRecoilState(onboardingProgress)
  const steps = getSteps(progress)

  return (
    <div className={classes.root}>
      <Stepper activeStep={progress.activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.title}>
            <StepLabel>{step.title}</StepLabel>
            <StepContent>
              <Elements stripe={stripePromise}>
                <Box pt={4}>{step.form}</Box>
              </Elements>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  )
}
